var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.container },
    [
      _c("MobileIconButton", {
        class: _vm.$style.closeBtn,
        attrs: {
          to: { name: "mobile-main" },
          symbol: "close-icon-white",
          "icon-size": "16"
        }
      }),
      _vm._v(" "),
      _c("div", { class: _vm.$style.content }, [
        _c("div", { class: _vm.$style.contentCenter }, [
          _c("h2", { class: _vm.$style.mainTitle }, [
            _vm._v("Order Submitted!")
          ]),
          _vm._v(" "),
          _c("svg", {
            directives: [{ name: "svg", rawName: "v-svg" }],
            class: _vm.$style.checkmark,
            attrs: { symbol: "checkmark-big", size: "119" }
          }),
          _vm._v(" "),
          _c("h3", { class: _vm.$style.orderNumber }, [
            _vm._v("\n        " + _vm._s(_vm.orderInfo.number) + "\n      ")
          ]),
          _vm._v(" "),
          _c("p", { class: _vm.$style.pickupMethod }, [
            _vm._v(_vm._s(_vm.orderType))
          ]),
          _vm._v(" "),
          _c("hr", { class: _vm.$style.delimiter }),
          _vm._v(" "),
          _c("div", { class: _vm.$style.orderInfo }, [
            _c("p", { class: _vm.$style.orderInfoText }, [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.infoIcon,
                attrs: { symbol: "account-icon", size: "18" }
              }),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.order.recipientName) +
                  " " +
                  _vm._s(_vm.order.phone) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { class: _vm.$style.orderInfoText }, [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.infoIcon,
                attrs: { symbol: "pin-white", size: "17 21" }
              }),
              _vm._v(
                "\n          " + _vm._s(_vm.restaurant.address) + "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { class: _vm.$style.orderInfoText }, [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.infoIcon,
                attrs: { symbol: "calendar-white", size: "17 19" }
              }),
              _vm._v("\n          " + _vm._s(_vm.orderTime) + "\n        ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { class: _vm.$style.bottomContent },
              [
                _c("p", [
                  _vm._v("Upon arrival, please call our store to notify us!")
                ]),
                _vm._v(" "),
                _c(
                  "MobileButton",
                  {
                    class: _vm.$style.callBtn,
                    attrs: {
                      href: "tel:" + _vm.restaurant.phone,
                      "btn-style": "round-big"
                    }
                  },
                  [_vm._v("\n            Call Store\n          ")]
                )
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileOrderConfirmation.vue?vue&type=template&id=8001a15e&
// module id = null
// module chunks = 